<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>send</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <h3>¿Está seguro de enviar el permiso ::?</h3>
        <br />
        <h4>Nota: Ya no podrá realizar cambios</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> No </v-btn>
        <v-btn
          color="success"
          @click.prevent="enviarPermiso()"
          :loading="loading"
        >
          Sí
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null,
      id_persona: null,
      rol: {}
    };
  },
  mounted() {
    this.$bus.$on("openDialogEnviarPermisoFuncionarioJefe", async item => {

      this.id = item.permiso.id;
      this.permiso = item;
      console.log('dialog this.permiso', this.permiso);
      // Obtnemos el correo del servidor seleccionado
      this.datos_usuario = await this.obtieneDatosPersona(
        this.permiso.id_persona
      );
      console.log(' this.datos_usuario', this.datos_usuario);
      this.dialog = true;
    });
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      console.log('permisodialog...',permiso);
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_permiso
      );
      
      if (!destinatario) {
        console.log('No hay destinatarios!')
        return;
      }

      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN SOLICITUD DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le envio una solicitud de permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>${permiso.tipo_permiso}<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_emision}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_retorno}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Ingrese al sistema para APROBAR o RECHAZAR EL PERMISO <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: `NOTIFICACIÓN SOLICITUD DE PERMISO`,
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.$bus.$emit("closeDialogEnviarFuncionarioJefe");
    },
    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },
    //solicita permiso
    async enviarPermiso() {
      let user = this.$storage.get("user");
      //console.log(this.$route.params.id)
      let id_persona = this.$route.params.id;
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      if (this.permiso.id_tipo_permiso == 87) {
        try {
         console.log(`
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`)
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_oficial;
          let resps2 = resp.split("|");
          console.log(resps2);
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }

      ////WC
      if (this.permiso.id_tipo_permiso == 104) {
        try {
         console.log(`
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`)
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_oficial;
          let resps2 = resp.split("|");
          console.log(resps2);
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }

///////// WC
      if (this.permiso.id_tipo_permiso == 103) {
        try {
         console.log(`
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`)
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_envia_permiso_oficial(${this.id},6,${
              user.id
            },${this.getUserId()})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_oficial;
          let resps2 = resp.split("|");
          console.log(resps2);
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }
//////


      if (this.permiso.id_tipo_permiso == 14) {
        try {
          console.log(`
              query{
                runQuery(consulta:"select control.fn_solicita_lic_personal(${this.id},6,${user.id})"){
                respuesta
                }
              }
            `);
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_solicita_lic_personal(${this.id},6,${user.id})"){
                respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_lic_personal;
          let resps2 = resp.split("|");
          console.log(resps2);
          if (resps2[0] == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      /// 105 QUE LA ENTIDAD OTORGUE
      if (this.permiso.id_tipo_permiso == 105) {
        try {
          console.log(`
              query{
                runQuery(consulta:"select control.fn_solicita_lic_entidad_otorgue(${this.id},6,${user.id})"){
                respuesta
                }
              }
            `);
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_solicita_lic_entidad_otorgue(${this.id},6,${user.id})"){
                respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_lic_entidad_otorgue;
          let resps2 = resp.split("|");
          console.log(resps2);
          if (resps2[0] == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }


      //permiso 102 trabajo continuo
      if (this.permiso.id_tipo_permiso == 102) {
        try {
         
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_solicita_horario_continuo(${this.id},6,${user.id},${this.permiso.id_persona})"){
                respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_horario_continuo;
          let resps2 = resp.split("|");
          console.log(resps2);
          if (resps2[0] == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 24) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_solicita_cta_vacacion(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_cta_vacacion;
          let resps2 = resp.split("|");
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 6) {
        try {
          console.log(`
							query{
								runQuery(consulta:"select control.fn_solicita_duelo(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`);
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_solicita_duelo(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_duelo;
          let resps2 = resp.split("|");
          let correcto = resps2[0] == 1;
          if (correcto == 1) {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 61) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_solicita_paternidad(${this.id},6,${user.id})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_paternidad;
          let resps2 = resp.split("|");
          let correcto = resps2[0] == 1;
          if (correcto) {
            this.$confirm("El permiso fué solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 88) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_envia_permiso_particular(${
                  this.id
                },6,${user.id},${this.getUserId()})"){
                  
                respuesta
                }
              }
              `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_particular;
          resp = resp.split("|");
          let correcto = resp[0];

          if (correcto == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 89) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${
                this.id
              },6,${user.id},${this.getUserId()})"){
                
              respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          if (correcto == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("Actualizacion de datos exitosa! " + resp, () => {});
          } else {
            this.$message.error(resp);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }

      if ( this.permiso.id_tipo_permiso >= 37 && this.permiso.id_tipo_permiso <= 43) {
        try {
          this.id = parseInt(this.id);
          user.id = parseInt(user.id);
          let respuesta = await this.$service.graphql({
            query: `
							query{
								runQuery(consulta:"select control.fn_solicita_pap_pros (${this.id},6,${user.id})"){
								respuesta
								}
							}
							`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_solicita_pap_pros;
          let resps2 = resp.split("|");
          let correcto = resps2[0] == 1;
          //enviar mensaje al funcionario:
          if (correcto) {
            //enviamos el correo al funcionario:
            if (this.datos_usuario) {
              var mensaje = `
            <h1>NOTIFICACIÓN - PERMISO TOLERANCIA</h1>
            Estimado(a): ${this.datos_usuario.nombres} ${this.datos_usuario.ap_paterno} ${this.datos_usuario.ap_materno}<br>
              En el marco del artículo 3 Decreto Supremo Nro. 3164, de 3 de mayo de 2017, usted cuenta con tres (3)días de plazo para presentar el formulario extendido por el servicio médico de la URH con la firma y sello del medico tratante.`;
              await this.$service.sendEmail({
                correo: this.datos_usuario.correo,
                asunto: `NOTIFICACIÓN - PERMISO TOLERANCIA`,
                mensaje: mensaje.replace(/<[^>]+>/g, ""),
                html: mensaje
              });
            } else {
              this.$message.info(
                "No se notifico por correo ya que el servidor no posee un correo registrado"
              );
            }
            this.$confirm("El permiso fué solicitado exitosamente", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1]);
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 12) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_envia_permiso_matrimonio(${
                  this.id
                },6,${user.id},${this.getUserId()})"){
                respuesta
                }
              }
              `
          });

          respuesta =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_matrimonio;
          let resps = respuesta.split("|");
          let correcto = resps[0];

          if (correcto === "1") {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resps[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }

      if (this.permiso.id_tipo_permiso == 94) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_envia_permiso_particular(${
                  this.id
                },6,${user.id},${this.getUserId()})"){
                  
                respuesta
                }
              }
              `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_envia_permiso_particular;
          resp = resp.split("|");
          let correcto = resp[0];

          if (correcto == "1") {
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            this.$confirm(resp[1], () => {});
          }
          this.close();
        } catch (error) {
          //cierra try
          console.log(error);
        } //cierra catch
      }

      if (this.permiso.id_tipo_permiso == 96) {
        try {
          this.id = parseInt(this.id);
          user.id = parseInt(user.id);
          let respuesta = await this.$service.graphql({
            query: `
                                query{
                                    runQuery(consulta:"select control.fn_solicita_anula_permiso(${
                                      this.id
                                    },6,${user.id},${this.getUserId()},'')"){
                                      respuesta
                                    }
                                  }	
                              `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_anula_permiso;
          let resp2 = resp.split("|");
          let correcto2 = resp2[0];

          if (correcto2 == "1") {
            this.permiso.id_estado = 6;
            this.$confirm("El permiso fue solicitado exitosamente", () => {});
          } else {
            // this.$message.error(resp)
            this.$confirm(resp2[1], () => {});
          }

          this.close();
        } catch (error) {
          console.log(error);
        }
      }


      await this.enviarCorreoDestinatario(permiso_copia);
      //console.log('enviarCorreoDestinatario',permiso_copia );
      this.loading = false;
    },

    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/EnviarPermisoFuncionarioJefe.vue